var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupportIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 37.5H9C4.8585 37.5 1.5 34.1415 1.5 30C1.5 25.8585 4.8585 22.5 9 22.5H10.5V37.5Z",
    stroke: "#2828F0",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39 37.5H37.5V22.5H39C43.1415 22.5 46.5 25.8585 46.5 30C46.5 34.1415 43.1415 37.5 39 37.5Z",
    stroke: "#2828F0",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 22.5V18C7.5 8.8875 14.8875 1.5 24 1.5C33.1125 1.5 40.5 8.8875 40.5 18V22.5",
    stroke: "#2828F0",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 37.5V43.5C40.5 45.1575 39.1575 46.5 37.5 46.5H33",
    stroke: "#2828F0",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27 46.5H30",
    stroke: "#2828F0",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24 36V39",
    stroke: "#2828F0",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24 33V29.0775C24 26.916 25.3155 24.9735 27.3225 24.171C29.8455 23.1615 31.5 20.718 31.5 18C31.5 13.8585 28.1415 10.5 24 10.5C19.8585 10.5 16.5 13.8585 16.5 18",
    stroke: "#2828F0",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIconBlue);
export default __webpack_public_path__ + "static/media/supportIconBlue.62c5bf3c6a288f83409e4fdf47a65fcb.svg";
export { ForwardRef as ReactComponent };